import React from "react";
import './styles.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { ROUTES } from "../../../utils/AppConstants";

const PageFooter = props => {
    let navigate = useNavigate();
    const { isHomePage = false, isPricingPage = false,
        isFeaturePage = false, isContactUsPage = false } = props

    const handleHomeClick = () => {
        navigate(ROUTES.home)
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // For an animated scroll; use 'auto' for instant jump
        });
    }

    const handleStorefrontClick = () => {
        window.open('https://retail.togethra.com', '_blank')
    }

    const handleAcademicClick = () => {
        window.open('https://academic.togethra.com', '_blank')
    }

    const handleTncClick = () => {
        navigate(ROUTES.tncPage)
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // For an animated scroll; use 'auto' for instant jump
        });
    }

    const handleCookiesClick = () => {
        navigate(ROUTES.cookiePolicy)
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // For an animated scroll; use 'auto' for instant jump
        });
    }

    const handlePrivacyClick = () => {
        navigate(ROUTES.privacyPolicy)
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // For an animated scroll; use 'auto' for instant jump
        });
    }

    const handleContactUsClick = () => {
        navigate(ROUTES.contactUs)
        window.scrollTo({
            top: 0,
            behavior: 'smooth' // For an animated scroll; use 'auto' for instant jump
        });
    }

    const handleEmailClick = () => {
        window.location.href = `mailto:contact@togethra.com?subject=${encodeURIComponent('Togethra- Contact Us')}`;
    }

    const getContainerClass = () => {
        if (isHomePage) {
            return `pf-footer-section pf-footer-section-home`
        } else if (isPricingPage) {
            return `pf-footer-section pf-footer-section-pricing`
        } else if (isFeaturePage) {
            return `pf-footer-section pf-footer-section-feature`
        } else if (isContactUsPage) {
            return `pf-footer-section pf-footer-section-contact-us`
        }
    }

    return (
        <div className={getContainerClass()}>
            <div className="container">
                <div className="row">
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <h5 className="pf-heading">Our Products</h5>
                        <div className="pf-label" onClick={() => { handleHomeClick() }}>For Businesses</div>
                        <div className="pf-label" onClick={() => { handleStorefrontClick() }}>For Retail</div>
                        <div className="pf-label" onClick={() => { handleAcademicClick() }}>For Academics</div>
                    </div>
                    <div className="col-sm-4 col-md-4 col-lg-4">
                        <h5 className="pf-heading">Links</h5>
                        <div className="pf-label" onClick={() => { handleTncClick() }}>Terms and Conditions</div>
                        <div className="pf-label" onClick={() => {
                            handlePrivacyClick()
                        }}>Privacy Policy</div>
                        <div className="pf-label" onClick={() => { handleCookiesClick() }}>Cookies Policy</div>
                    </div>
                    <div className="col-4 d-block d-md-none">
                        <h5 className="pf-heading">Contact Us</h5>
                        <div className="pf-label" onClick={() => { handleEmailClick() }}>contact@togethra.com</div>
                        <div className="pf-label">or</div>
                        <div className="pf-label text-decoration-underline" onClick={() => { handleContactUsClick() }}>Click Here</div>
                    </div>
                    <div className="col-md-4 col-lg-4 d-none d-md-block">
                        <h5 className="pf-heading text-center">Contact Us</h5>
                        <div className="pf-label text-center" onClick={() => { handleEmailClick() }}>contact@togethra.com</div>
                        <div className="pf-label text-center">or</div>
                        <div className="pf-label text-center text-decoration-underline" onClick={() => { handleContactUsClick() }}>Click Here</div>
                    </div>
                </div>
            </div>
            <div className="pf-credits text-center">&#169; {new Date().getFullYear()} Togethra • Product & Engineering</div>

        </div>
    )
}

export default PageFooter